<template>
  <div class="schedule-detail">
    <v-data-table
      class="custom-data-table schedule-detail-table"
      :headers="headers"
      :items="list"
      :search="search"
      :loading="isLoadingTable"
      loading-text="Loading..."
      fixed-header
      height="470px"
      v-model="syncSelected"
      item-key="name"
      show-select
    >
      <!-- Header checkBox -->
      <template v-slot:[`header.data-table-select`]="{ props, on }">
        <v-simple-checkbox
          v-bind="props"
          v-on="on"
          class="custom-checkbox"
          on-icon="$vuetify.icons.checkboxIcon"
          off-icon="$vuetify.icons.checkboxFalseIcon"
        />
      </template>
      <!-- table body checkBox -->
      <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
        <v-simple-checkbox
          :value="isSelected"
          @input="select($event)"
          class="custom-checkbox"
          on-icon="$vuetify.icons.checkboxIcon"
          off-icon="$vuetify.icons.checkboxFalseIcon"
        />
      </template>
      <!-- Footer -->
      <template v-slot:footer.page-text="props">
        {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}
      </template>

      <template v-slot:no-results>
        <div class="detail-table-icon">
          <v-img
            class="mx-auto mb-3"
            :src="require(`@/assets/images/general/icon_no-results.svg`)"
            width="39"
            contain
            height="51"
          />
          <p class="text-body-3 neutral-043--text mb-192">
            {{ $t('STAFF_MANAGEMENT.NO_MATCH_ROSTER_SCHEDULE') }}
          </p>
        </div>
      </template>
      <template v-slot:no-data>
        <div class="detail-table-icon">
          <v-img
            class="mx-auto mb-3"
            :src="require(`@/assets/images/general/icon_no-results.svg`)"
            width="39"
            contain
            height="51"
          />
          <p class="text-body-3 neutral-043--text">
            {{ $t('STAFF_MANAGEMENT.NO_EXIST_ROSTER_SCHEDULE') }}
          </p>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ScheduleDetailTable',
  components: {
  },
  props: {
    headers: {
      type: Array,
      default() {
        return [];
      }
    },
    isLoadingTable: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    selected: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    syncSelected: {
      get() {
        return this.selected;
      },
      set(val) {
        this.$emit('update:selected', val);
      }
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.schedule-detail {
  max-width: 750px;
  position: relative;
}

::v-deep.schedule-detail-table {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    left: 192px;
    top: 0;
    height: 470px;
    width: 1px;
    background-color: $neutral-cold-056;
  }
  &.v-data-table .v-data-table__wrapper {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &.v-data-table .v-data-table__wrapper > table {
    > thead > tr > th, > tbody > tr > td {
      padding: 8px;
    }
    > thead > tr > th:first-child,> tbody > tr > td:first-child {
      position: sticky;
      left: 0;
      z-index: 5;
      padding: 8px 0 8px 30px;
      .v-input--selection-controls__input {
        width: 22px;
        height: 22px;
      }
      .v-input--selection-controls__ripple {
        height: 32px;
        width: 32px;
        top: calc(50% - 23px);
      }
    }
    > thead > tr > th:nth-child(2), > tbody > tr > td:nth-child(2) {
      position: sticky;
      left: 60px;
      z-index: 5;
      border-right: 1px solid $neutral-cold-056;
      padding: 8px;
    }
    > thead > tr > th:first-child, > thead > tr > th:nth-child(2) {
      z-index: 6;
    }
    > thead > tr > th:nth-child(3), > tbody > tr > td:nth-child(3) {
      padding-left: 16px;
    }
    > tbody > tr.v-data-table__empty-wrapper > td:first-child {
      position: static;
      .detail-table-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    tbody tr:nth-child(odd):not(.v-data-table__empty-wrapper) {
      > td:first-child, > td:nth-child(2) {
        background-color: $neutral-cold-058;
      }
      &.v-data-table__selected {
        background: #f5f5f5;
        > td:first-child, > td:nth-child(2) {
          background: #f5f5f5;
        }
      }
      &.v-data-table__selected:hover {
        > td:first-child, > td:nth-child(2) {
          background: $neutral-cold-058;
        }
      }
    }
    tbody tr:nth-child(even):not(.v-data-table__empty-wrapper) {
      > td:first-child, > td:nth-child(2) {
        background-color: $neutral-047;
      }
      &.v-data-table__selected {
        background: #f5f5f5;
        > td:first-child, > td:nth-child(2) {
          background: #f5f5f5;
        }
      }
      &.v-data-table__selected:hover {
        > td:first-child, > td:nth-child(2) {
          background: $neutral-cold-056;
        }
      }
    }

    tbody tr:hover:not(.v-data-table__empty-wrapper){
      > td:first-child, > td:nth-child(2) {
        background: $neutral-cold-056;
      }
    }
    tbody tr.v-data-table__selected {
      > td:first-child, > td:nth-child(2) {
        background: #f5f5f5;
      }
    }
  }
}
</style>
